import Box from '@mui/material/Box/Box'

import DeleteButton from 'ui/buttons/DeleteButton'
import '../../../../styles/notif.css'

import CircularProgress from '@mui/material/CircularProgress/CircularProgress'
import NotificationItem from 'components/notifications/components/notification-card/NotificationItem'
import axAPI from 'httpConfig'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
const NotificationsPrev = ({
	prevNotif,
	remove,
	setPrevNotifications,
	setCountNotif,
	fetching,
	setOpenNotifications,
}) => {
	const removeAllPrevNotifications = () => {
		setPrevNotifications([])
		axAPI({
			method: 'PATCH',
			url: `notifications/bulk`,
			data: { id: [], close_today: false, close_old: true },
		}).then(response => {
			if (response.status === 201)
				axAPI({
					method: 'GET',
					url: 'notifications/count',
				}).then(response => {
					setCountNotif(response.data.new_count)
				})
		})
	}
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '8px',
				}}
			>
				<TypographyPrimary>Прошедшие</TypographyPrimary>
				<Box onClick={removeAllPrevNotifications}>
					<DeleteButton children={'Очистить'} />
				</Box>
			</Box>
			<TransitionGroup>
				{prevNotif.map(el => (
					<CSSTransition key={el.id} timeout={500} classNames={'notif'}>
						<NotificationItem
							remove={remove}
							{...el}
							setOpenNotifications={setOpenNotifications}
						/>
					</CSSTransition>
				))}
			</TransitionGroup>
			{fetching ? (
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<CircularProgress
						sx={{
							'&.MuiCircularProgress-colorPrimary': { color: COLORS.main },
						}}
					/>
				</Box>
			) : (
				<></>
			)}
		</Box>
	)
}

export default NotificationsPrev
